/**
 * Typed fetch wrappers for the firewall POC endpoints.
 * STUB — Pkg F implements the calls.
 */

export interface PocStatus {
  trial_id: string;
  org_slug: string;
  expires_at: string;
  days_remaining: number;
  grace_active: boolean;
  expired: boolean;
  token_usage_today?: number;
  daily_token_budget?: number;
}

export interface PocScenario {
  scenario_id: string;
  title: string;
  description: string;
  steps: string[];
  sort_order: number;
}

export interface PocProgress {
  scenario_id: string;
  step_index: number;
  completed_at: string | null;
}

/** Runtime config injected by the container at start (see public/env-config.js). */
const RUNTIME_ENV: { API_URL?: string; API_PORT?: string; POC_MODE?: string } =
  (typeof window !== 'undefined' && (window as any).__ZTAI_ENV__) || {};

/** True when the dashboard is running inside a POC customer stack. */
export const POC_MODE =
  RUNTIME_ENV.POC_MODE === 'true' || process.env.REACT_APP_POC_MODE === 'true';

/** Firewall API base — runtime config first, then build-time env, then derive from origin. */
const API = (
  (RUNTIME_ENV.API_PORT && typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.hostname}:${RUNTIME_ENV.API_PORT}`
    : '') ||
  RUNTIME_ENV.API_URL ||
  process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.hostname}:3000`
    : '')
).replace(/\/$/, '');

export async function getPocStatus(): Promise<PocStatus> {
  const res = await fetch(`${API}/poc/status`);
  if (!res.ok) throw new Error(`Failed to fetch POC status: ${res.statusText}`);
  return res.json();
}

export async function getPocScenarios(): Promise<PocScenario[]> {
  const res = await fetch(`${API}/poc/scenarios`);
  if (!res.ok) throw new Error(`Failed to fetch POC scenarios: ${res.statusText}`);
  return res.json();
}

export async function getPocProgress(): Promise<PocProgress[]> {
  const res = await fetch(`${API}/poc/progress`);
  if (!res.ok) throw new Error(`Failed to fetch POC progress: ${res.statusText}`);
  return res.json();
}

export async function markStepComplete(
  scenarioId: string,
  stepIndex: number
): Promise<void> {
  const res = await fetch(`${API}/poc/progress/${encodeURIComponent(scenarioId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ step_index: stepIndex }),
  });
  if (!res.ok) throw new Error(`Failed to mark step complete: ${res.statusText}`);
}

export async function requestExtension(): Promise<void> {
  const res = await fetch(`${API}/poc/request-extension`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
  if (!res.ok) throw new Error(`Failed to request extension: ${res.statusText}`);
}
